"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _reactI18next = require("react-i18next");
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _Button = _interopRequireDefault(require("../Button"));
var ButtonGroup = function ButtonGroup(_ref) {
  var _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? false : _ref$isValid,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$isLast = _ref.isLast,
    isLast = _ref$isLast === void 0 ? false : _ref$isLast,
    onBack = _ref.onBack,
    onClick = _ref.onClick,
    children = _ref.children;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var render = function render() {
    if (isLoading) {
      return /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
        size: "1.5rem",
        color: "inherit"
      });
    } else if (children) {
      return children;
    } else {
      return isLast ? t('signup.confirm') : t('signup.next');
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex md:mb-5"
  }, !(0, _isNil["default"])(onBack) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "button",
    color: "secondary",
    className: "hidden w-full mr-3 md:block md:w-1/2",
    onClick: onBack,
    disabled: isLoading
  }, t('signup.back')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: onClick ? 'button' : 'submit',
    color: "primary",
    onClick: onClick,
    className: "flex justify-center w-full md:w-1/2 align-center",
    disabled: !isValid || isLoading
  }, render()));
};
var _default = exports["default"] = ButtonGroup;
//# sourceMappingURL=ButtonGroup.js.map